module.exports = __webpack_public_path__ + "img/custom_value_bg_img.bd14cfc0.png";